import Checkbox from '@allesauto/core/checkbox';
import translate from '@allesauto/i18n';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

export interface NewsletterSubscribeCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  isDarkBg?: boolean;
}

const NewsletterSubscribeCheckbox: FC<
  React.PropsWithChildren<
    React.PropsWithChildren<NewsletterSubscribeCheckboxProps>
  >
> = ({ checked, onChange, isDarkBg }) => {
  const intl = useIntl();

  const className = {
    label: clsx('text-p3', isDarkBg ? 'text-white' : 'text-grey60'),
  };

  return (
    <Checkbox
      label={
        <div className={className.label}>
          {translate(intl, 'ui.FORMS.NEWSLETTER.PARTIAL.CHECKBOX')}
        </div>
      }
      onChange={onChange}
      checked={checked}
      darkBg={isDarkBg}
    />
  );
};

export default NewsletterSubscribeCheckbox;
